var map = {
	"./782114.jpg": "07b6",
	"./832336.jpg": "33b5",
	"./867814.jpg": "4758",
	"./belleplagne.jpg": "e191",
	"./cedre.jpg": "0801",
	"./chateaulaval.jpg": "a332",
	"./horizondulac.jpg": "30df",
	"./hotelbalmoral.jpg": "7715",
	"./jonzac.jpg": "9dac",
	"./larochelle.jpg": "0f29",
	"./nicehotel.jpg": "ee4f",
	"./saintsaturin.jpg": "eae4",
	"./saintsimon.jpg": "7a0f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "016b";